<script lang="ts">
    import { Assignment } from '../Assignment';
    import QuickCategoryListItemValue from './QuickCategoryListItemValue.svelte';

    export let assignment: Assignment;

    $: {
        assignment = assignment;
    }
</script>

<div>
    <div class="quick-category-details">
        {#if assignment.isDefault() || assignment.isAdHoc() || assignment.isVehicleGroup() || assignment.isFake()}
            {#if assignment.isAdHoc()}
                <QuickCategoryListItemValue
                    {assignment}
                    categoryId="to_assign"
                    showStartArrow={true}
                    showEndArrow={true}
                />
            {/if}
            <QuickCategoryListItemValue
                {assignment}
                categoryId="to_approve"
                showStartArrow={true}
                showEndArrow={true}
            />
            <QuickCategoryListItemValue
                {assignment}
                categoryId="to_send"
                showStartArrow={true}
                showEndArrow={true}
            />
            <QuickCategoryListItemValue
                {assignment}
                categoryId="in_progress"
                showStartArrow={true}
                showEndArrow={true}
            />
        {:else}
            <QuickCategoryListItemValue
                {assignment}
                categoryId="to_assign"
                showStartArrow={true}
                showEndArrow={true}
                wider={true}
            />
        {/if}
    </div>
</div>

<style>
    .quick-category-details {
        display: flex;
        justify-content: space-between;
        align-items: center;
        column-gap: -3px;
    }
</style>
